module.exports = __webpack_public_path__ + "static/media/RULEBOOK_KOREAN.e3534eea.pdf";